import LocalizedStrings from 'react-localization';
import { constructNameEN } from '../../employee/employee-name-helper';
import { withCommon } from '../../services/translation/commonTranslations';

const pageStrings = new LocalizedStrings({
  en: {
    nav: {
      logout: 'Sign Out',
      myProfile: 'My profile',
      myData: 'My data',
      uiTest: 'UI Testing',
      staffList: 'Staff List',
      manageOrg: 'Manage Organisation',
      dataManagement: 'Data Management',
      tenantSettings: 'Tenant Settings',
      manageLocation: 'Manage Location',
      mobileOpenMenu: 'Open main menu',
      lockedFeature: 'This feature of TimeShift is not unlocked.',
      pageNames: {
        me: 'Me',
        team: 'Team',
        sandbox: 'Sandbox',
        shifts: 'Shifts',
        roster: 'Rosters',
        templates: 'Templates',
        myShifts: 'My Shifts',
        healthAndSafety: 'Health & Safety',
        calendar: 'Calendar',
        admin: 'Admin',
        tenantManagement: 'Tenant Management',
        dataManagement: 'Data Management',
        tenantSettings: 'Tenant Settings'
      }
    },
    employeeName: constructNameEN,
    locationSelect: {
      pleaseSelect: 'Please select',
      selectLocation: 'Select Location'
    }
  }
});

export default withCommon<typeof pageStrings>(pageStrings);
